import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import { Plus } from 'react-bootstrap-icons'
import { CampaignContext } from '../../../../contexts/CampaignContext'
import { toastSuccess } from '../../../FormComponents/Toasts'
import BudgetTableSection from './BudgetTableParts/BudgetTableSection'
import { mergeActiveScenarios } from './BudgetTableParts/mergeActiveScenarios'
import Overview from './BudgetTableParts/Overview'
import { useReadOnly } from '../../../../contexts/ReadOnlyContext'

export default observer(function BudgetTableNew() {
  const { campaignScenarios, createCampaignScenario } = useContext(CampaignContext)
  const readOnly = useReadOnly()

  const mergedScenario = mergeActiveScenarios(campaignScenarios)

  const handleAddBudgetTable = () => {
    createCampaignScenario(`Budget Table ${campaignScenarios.length + 1}`)
      .then(() => toastSuccess('Budget table added'))
      .catch(() => {})
  }

  return (
    <div className="pt-14 px-4 dark:bg-rb-dark-mode-background" style={{ minWidth: '82vw' }}>
      <Overview campaignScenario={mergedScenario} />
      <div className="mt-4 rounded-3xl bg-white dark:bg-rb-dark-mode-background p-4">
        <p className="font-bold text-xl dark:text-white mb-4">Budget Details</p>
        {campaignScenarios.map((campaignScenario, index) => (
          <BudgetTableSection
            key={campaignScenario.id}
            campaignScenario={campaignScenario}
            canDelete={campaignScenarios.length > 1}
            isFirst={index === 0}
          />
        ))}
        {!readOnly && (
          <div className="mt-6 pt-6 border-t-1 border-border-primary dark:border-rb-dark-mode-lighter flex justify-center">
            <button
              type="button"
              onClick={handleAddBudgetTable}
              className="flex items-center gap-2 rounded-full border-1 border-rb-green text-rb-green dark:text-rb-green px-4 py-2 bg-white dark:bg-rb-dark-mode"
            >
              <Plus />
              Add budget table
            </button>
          </div>
        )}
      </div>
    </div>
  )
})
